import React, { useEffect, useState } from "react";
import {
  Chart as ChartJs,
  ArcElement,
  Tooltip,
  Legend,
  LinearScale,
} from "chart.js";
import datalabels from "chartjs-plugin-datalabels";
import { Doughnut } from "react-chartjs-2";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import "./warrantyChart.css";

ChartJs.register(ArcElement, Tooltip, Legend, LinearScale, datalabels);

const WarrantyChart = () => {
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const baseUrl =
    "https://api.generalhome.sa/api/Reports/GetWarrantyStatusRequests";

  useEffect(() => {
    const fetchInfo = async () => {
      try {
        const maintenanceAreaIdsString =
          localStorage.getItem("MaintenanceAreaIds");
        const maintainceAreaId = maintenanceAreaIdsString
          ? maintenanceAreaIdsString.split(",").map(Number)
          : [];

        const response = await axios.post(
          baseUrl,
          { maintenanceAreaIds: maintainceAreaId },
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        );

        // Ensure we're working with an array
        const data = Array.isArray(response.data) ? response.data : [];
        setChartData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to load warranty data");
      } finally {
        setLoading(false);
      }
    };

    fetchInfo();
  }, []);

  const insideWarrantyObj = chartData.find(
    (x) => x.WarrantyStatusName === "داخل الضمان"
  );
  const outsideWarrantyObj = chartData.find(
    (x) => x.WarrantyStatusName === "خارج الضمان"
  );

  const insideWarranty = insideWarrantyObj?.RequestCount || 0;
  const outsideWarranty = outsideWarrantyObj?.RequestCount || 0;
  const total = insideWarranty + outsideWarranty;

  const data = {
    labels: ["داخل الضمان", "خارج الضمان"],
    datasets: [
      {
        label: "حالة الضمان",
        data: [insideWarranty, outsideWarranty],
        backgroundColor: ["#C2E3FF", "#FFA537"],
        borderWidth: 2,
        borderColor: "#fff",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "70%",
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
      datalabels: {
        display: false,
      },
    },
  };

  const centerTextPlugin = {
    id: "centerText",
    beforeDraw(chart) {
      const { ctx, chartArea } = chart;
      if (!chartArea) return;

      const centerX = (chartArea.left + chartArea.right) / 2;
      const centerY = (chartArea.top + chartArea.bottom) / 2;

      ctx.save();
      ctx.fillStyle = "#333";
      ctx.font = "bold 14px Cairo";
      ctx.textAlign = "center";

      ctx.fillText("إجمالي حالات الضمان", centerX, centerY - 10);
      ctx.fillText(total.toString(), centerX, centerY + 15);
      ctx.restore();
    },
  };

  if (loading) {
    return (
      <div className="loading-container">
        <ClipLoader color="#00b1ff" size={50} />
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="warrantyChart">
      <div className="warrantyChart-container">
        <div className="info-box">
          <h4>حالة الضمان</h4>
          <input type="month" id="month" name="month" value="2025-01" />
        </div>
        <div className="data-container">
          <div className="data">
            <div className="outOfWarr d-flex justify-content-between">
              <div className="box-wrapper">
                <div className="red-circle"></div>
                <div className="box">
                  <h5>خارج الضمان</h5>
                  <p>
                    المنتجات خارج الضمان %
                    {total ? ((outsideWarranty / total) * 100).toFixed(1) : 0}
                  </p>
                </div>
              </div>
              <div>
                <h6>{outsideWarranty}</h6>
              </div>
            </div>
            <div className="outOfWarr d-flex justify-content-between">
              <div className="box-wrapper">
                <div className="green-circle"></div>
                <div className="box">
                  <h6>داخل الضمان</h6>
                  <p>
                    المنتجات داخل الضمان %
                    {total ? ((insideWarranty / total) * 100).toFixed(1) : 0}
                  </p>
                </div>
              </div>
              <div>
                <h6>{insideWarranty}</h6>
              </div>
            </div>
          </div>
          <div className="chart-container">
            <Doughnut
              data={data}
              options={options}
              plugins={[centerTextPlugin]}
              height={200}
              width={200}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WarrantyChart;
